export const MODAL_PAGE_DEFAULT_PERCENT_HEIGHT = 75;
